import _ from 'lodash';
import {c1Api, c2Api, c3Api} from '../apis/imonggoApi'

import {
    SIGN_IN,
    SIGN_OUT,
    FETCH_COLLECTIONS,
    FETCH_STATISTICS
} from './types';

export const signIn = (userId, email, imageUrl, token) => {
    return {
        type: SIGN_IN,
        payload: {userId, email, imageUrl, token}
    }
}

export const signOut = () => {
    return {
        type: SIGN_OUT
    }
}

export const fetchCollections = (year, token) => async (dispatch) => {
    const headers = {auth: {
        username: token,
        password: 'x'
    }}
    const from = `${year}-01-01`
    const to = `${year}-12-31`
    const responseAll = await Promise.all([
                                           c1Api.get(`pay_pal_collections.json?from=${from}&to=${to}`, headers), 
                                           c2Api.get(`pay_pal_collections.json?from=${from}&to=${to}`, headers),    
                                           c3Api.get(`pay_pal_collections.json?from=${from}&to=${to}`, headers),    
                                           c1Api.get(`stripe_collections.json?from=${from}&to=${to}`, headers), 
                                           c2Api.get(`stripe_collections.json?from=${from}&to=${to}`, headers), 
                                           c3Api.get(`stripe_collections.json?from=${from}&to=${to}`, headers),
                                           c1Api.get(`ytd_collection.json?from=${from}&to=${to}`, headers),
                                           c2Api.get(`ytd_collection.json?from=${from}&to=${to}`, headers),
                                           c3Api.get(`ytd_collection.json?from=${from}&to=${to}`, headers)
                                        ]) 

    const c1PayPalCollections =  _.mapKeys(responseAll[0].data.collections, (value, key)  => `${value.month}-${value.year}`);
    const c1PayPalRefunds     =  _.mapKeys(responseAll[0].data.refunds, (value, key)      => `${value.month}-${value.year}`);
    const c2PayPalCollections =  _.mapKeys(responseAll[1].data.collections, (value, key)  => `${value.month}-${value.year}`);
    const c2PayPalRefunds     =  _.mapKeys(responseAll[1].data.refunds, (value, key)      => `${value.month}-${value.year}`);
    const c3PayPalCollections =  _.mapKeys(responseAll[2].data.collections, (value, key)  => `${value.month}-${value.year}`);
    const c3PayPalRefunds     =  _.mapKeys(responseAll[2].data.refunds, (value, key)      => `${value.month}-${value.year}`);
    const c1StripeCollections =  _.mapKeys(responseAll[3].data.collections, (value, key)  => `${value.month}-${value.year}`);
    const c1StripeRefunds     =  _.mapKeys(responseAll[3].data.refunds, (value, key)      => `${value.month}-${value.year}`);
    const c2StripeCollections =  _.mapKeys(responseAll[4].data.collections, (value, key)  => `${value.month}-${value.year}`);
    const c2StripeRefunds     =  _.mapKeys(responseAll[4].data.refunds, (value, key)      => `${value.month}-${value.year}`);
    const c3StripeCollections =  _.mapKeys(responseAll[5].data.collections, (value, key)  => `${value.month}-${value.year}`);
    const c3StripeRefunds     =  _.mapKeys(responseAll[5].data.refunds, (value, key)      => `${value.month}-${value.year}`);

    const payPalCollectionsYtd = responseAll[6].data.total_pay_pal_collections + responseAll[7].data.total_pay_pal_collections + responseAll[8].data.total_pay_pal_collections;
    const payPalRefundsYtd     = responseAll[6].data.total_pay_pal_refunds + responseAll[7].data.total_pay_pal_refunds + responseAll[8].data.total_pay_pal_refunds;
    const stripeCollectionsYtd = responseAll[6].data.total_stripe_collections + responseAll[7].data.total_stripe_collections + responseAll[8].data.total_stripe_collections;
    const stripeRefundsYtd     = responseAll[6].data.total_stripe_refunds + responseAll[7].data.total_stripe_refunds + responseAll[8].data.total_stripe_refunds;
    const overallTotal         = responseAll[6].data.overall_total + responseAll[7].data.overall_total + responseAll[8].data.overall_total;

    const c1 = {
        stripeCollections: c1StripeCollections,
        stripeRefunds:     c1StripeRefunds,
        payPalCollections: c1PayPalCollections,
        payPalRefunds:     c1PayPalRefunds
    }
    const c2 = {
        stripeCollections: c2StripeCollections,
        stripeRefunds:     c2StripeRefunds,
        payPalCollections: c2PayPalCollections,
        payPalRefunds:     c2PayPalRefunds
    }
    const c3 = {
        stripeCollections: c3StripeCollections,
        stripeRefunds:     c3StripeRefunds,
        payPalCollections: c3PayPalCollections,
        payPalRefunds:     c3PayPalRefunds
    }                   
    dispatch({
        type: FETCH_COLLECTIONS,
        payload: {year, c1, c2, c3, payPalCollectionsYtd, payPalRefundsYtd, stripeCollectionsYtd, stripeRefundsYtd, overallTotal}
    })
}

export const fetchStatistics = (year, token) => async (dispatch) => {
    const headers = {auth: {
        username: token,
        password: 'x'
    }}

    const responseAll = await Promise.all([
        c1Api.get(`monthly_snapshot.json?year=${year}`, headers), 
        c2Api.get(`monthly_snapshot.json?year=${year}`, headers), 
        c3Api.get(`monthly_snapshot.json?year=${year}`, headers)
     ])

     const c1Statistics =  responseAll[0].data;
     const c2Statistics =  responseAll[1].data;
     const c3Statistics =  responseAll[2].data;

     dispatch({
         type: FETCH_STATISTICS,
         payload: {year, c1Statistics, c2Statistics, c3Statistics}
     })
} 